<div
  *transloco="let t; read: 'widgets.options'"
  class="xi-modal__container donut-chart-options-dialog__container"
>
  <h2 class="xi-modal__title kxi-text-center">{{ t('chart-options') }}</h2>

  <form class="xi-modal__content donut-chart-options-dialog__form" [formGroup]="form">
    <div class="donut-chart-options-dialog__section">
      <div class="donut-chart-options-dialog__section-header">{{ t('inner-number') }}</div>

      <div class="donut-chart-options-dialog__section-content">
        <div class="donut-chart-options-dialog__section">
          <div class="donut-chart-options-dialog__section-sub-header">
            {{ t('metric-calculation') }}
          </div>

          <div class="donut-chart-options-dialog__section-content">
            <div class="donut-chart-options-dialog__metric-container">
              <div class="donut-chart-options-dialog__metric-radios-container">
                <xi-radio
                  [label]="t('average')"
                  value="avg"
                  formControlName="metric"
                  name="metricRadio"
                  color="CX"
                ></xi-radio>

                <xi-radio
                  [label]="t('sum')"
                  value="sum"
                  formControlName="metric"
                  name="metricRadio"
                  color="CX"
                ></xi-radio>

                <div class="donut-chart-options-dialog__metric-box-radio-row">
                  <xi-radio
                    [label]="t('box')"
                    value="box"
                    formControlName="metric"
                    name="metricRadio"
                    color="CX"
                  ></xi-radio>

                  <xi-dropdown
                    select="single"
                    formControlName="metricBoxType"
                    [data]="boxTypeSet"
                    class="donut-chart-options-dialog__box-type-dropdown"
                  ></xi-dropdown>

                  <xi-dropdown
                    select="single"
                    formControlName="metricBoxSize"
                    [data]="boxSizeSet"
                    class="donut-chart-options-dialog__box-size-dropdown"
                  ></xi-dropdown>
                </div>

                <xi-radio
                  [label]="t('nps')"
                  value="nps"
                  formControlName="metric"
                  name="metricRadio"
                  color="CX"
                ></xi-radio>
              </div>
            </div>

            <div class="donut-chart-options-dialog__rating-container">
              <div class="donut-chart-options-dialog__min-rating-group">
                <label class="kxi-input-label">{{ t('minimum-rating') }}</label>

                <xi-toggle-switch
                  [leftText]="0"
                  [rightText]="1"
                  type="button"
                  [isToggled]="form.controls.minRating.value === 1"
                  (onToggle)="form.controls.minRating.setValue($event.detail.isToggled ? 1 : 0)"
                  color="CX"
                ></xi-toggle-switch>
              </div>

              <xi-input-field
                required
                [label]="t('maximum-rating')"
                formControlName="maxRating"
                type="number"
                [min]="2"
                [max]="1000"
              ></xi-input-field>
            </div>

            <xi-dropdown
              select="single"
              [label]="t('decimal-precision')"
              formControlName="decimalPrecision"
              [data]="decimalPrecisionSet"
              class="donut-chart-options-dialog__decimal-precision-dropdown"
            ></xi-dropdown>
          </div>
        </div>

        <div class="donut-chart-options-dialog__section">
          <div class="donut-chart-options-dialog__section-sub-header">
            {{ t('comparison-options') }}
          </div>

          <div class="donut-chart-options-dialog__section-content">
            <div class="donut-chart-options-dialog__comparison-container">
              <div class="donut-chart-options-dialog__comparison-label">{{ t('increase') }}:</div>

              @for (comparisonColorRadio of comparisonColorRadios; track comparisonColorRadio) {
                <xi-radio
                  [label]="comparisonColorRadio.label"
                  [value]="comparisonColorRadio.value"
                  formControlName="increaseColor"
                  name="increaseColorRadio"
                  color="CX"
                ></xi-radio>
              }

              <div class="donut-chart-options-dialog__comparison-label">{{ t('decrease') }}:</div>

              @for (comparisonColorRadio of comparisonColorRadios; track comparisonColorRadio) {
                <xi-radio
                  [label]="comparisonColorRadio.label"
                  [value]="comparisonColorRadio.value"
                  formControlName="decreaseColor"
                  name="decreaseColorRadio"
                  color="CX"
                ></xi-radio>
              }

              <div class="donut-chart-options-dialog__comparison-label">{{ t('show-as') }}</div>

              <xi-toggle-switch
                [leftText]="t('absolute')"
                [rightText]="t('percentage')"
                type="button"
                [isToggled]="form.controls.showAs.value === 'percentage'"
                (onToggle)="
                  form.controls.showAs.setValue($event.detail.isToggled ? 'percentage' : 'absolute')
                "
                color="CX"
                class="donut-chart-options-dialog__comparison-toggle"
              ></xi-toggle-switch>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="donut-chart-options-dialog__separator"></div>

    <div class="donut-chart-options-dialog__section">
      <div class="donut-chart-options-dialog__section-header">{{ t('donut-ring') }}</div>

      <div class="donut-chart-options-dialog__section-content">
        <div class="donut-chart-options-dialog__section">
          <div class="donut-chart-options-dialog__section-sub-header">
            {{ t('metric-calculation') }}
          </div>

          <div class="donut-chart-options-dialog__section-content">
            <xi-dropdown
              select="single"
              formControlName="scoring"
              [data]="scoringSet"
              class="donut-chart-options-dialog__scoring-dropdown"
            ></xi-dropdown>
          </div>
        </div>

        <div class="donut-chart-options-dialog__section">
          <div class="donut-chart-options-dialog__section-sub-header">
            {{ t('display.title') }}
          </div>

          <div class="donut-chart-options-dialog__section-content">
            <app-box-scoring-display
              [data]="boxScoringDisplayData"
              [disabled]="form.controls.scoring.value !== 'box'"
              (update)="onBoxScoringDisplayChanged($event)"
            ></app-box-scoring-display>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div class="xi-modal__actions donut-chart-options-dialog__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="onCancel()"></xi-default-button>

    <xi-default-button
      [text]="t('apply')"
      [disabled]="form.invalid || !isBoxScoringDisplayDataValid"
      (onClick)="onSave()"
    ></xi-default-button>
  </div>
</div>
